import { computed, watch } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { S as SingleMessage, u as useInputProps } from "./assets/SingleMessage-Dv2wNb7f.js";
import { u as useValidationsProp } from "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/XIcon-U9bwokTN.js";
import "@fortawesome/vue-fontawesome";
const MessagesContainer$1 = "_MessagesContainer_bfgjf_1";
const style0 = {
  MessagesContainer: MessagesContainer$1
};
const { MESSAGE_TYPES, createMessageProps, createAdditionalMessagesProp } = useInputProps();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const { createValidationsProp, setupValidations } = useValidationsProp();
const __default__ = {
  name: "MessagesContainer",
  components: {
    SingleMessage
  }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    ...createValidationsProp(),
    ...createAdditionalMessagesProp(),
    ...createTestIdProp(),
    ...createMessageProps()
  },
  emits: [MESSAGE_TYPES.error],
  setup(__props, { emit }) {
    const props = __props;
    const { formatTestId } = setupTestId(props);
    const computedValidations = computed(() => props.validations);
    const { validationError } = setupValidations(computedValidations);
    const computedMessage = computed(() => props.message || validationError.value);
    const hasMessage = computed(() => computedMessage.value || props.additionalMessages.length > 0);
    const hasErrorAtAdditionalMessages = computed(
      () => !!props.additionalMessages.find((msg) => msg.type === MESSAGE_TYPES.error || !(msg == null ? void 0 : msg.type))
    );
    const hasError = computed(
      () => props.message && props.messageType === MESSAGE_TYPES.error || hasErrorAtAdditionalMessages.value || !!validationError.value
    );
    watch(
      () => hasError.value,
      () => {
        emit(MESSAGE_TYPES.error, hasError.value);
      },
      { immediate: true }
    );
    return { __sfc: true, MESSAGE_TYPES, createMessageProps, createAdditionalMessagesProp, createTestIdProp, setupTestId, createValidationsProp, setupValidations, props, emit, formatTestId, computedValidations, validationError, computedMessage, hasMessage, hasErrorAtAdditionalMessages, hasError, SingleMessage };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.hasMessage, expression: "hasMessage" }], class: _vm.$style.MessagesContainer }, [_c(_setup.SingleMessage, { attrs: { "message": _setup.computedMessage, "message-type": _vm.messageType, "data-testid": _setup.formatTestId("message") } }), _vm._l(_vm.additionalMessages, function(item, index) {
    return _c(_setup.SingleMessage, { key: item.message, attrs: { "message": item.message, "message-type": item.type || _setup.MESSAGE_TYPES.error, "data-testid": _setup.formatTestId(`message_${index}`) } });
  })], 2);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const MessagesContainer = __component__.exports;
export {
  MessagesContainer as default
};
